var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConceptValidation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_121_60082)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.564 25.3418C113.903 31.6107 113.881 37.736 114.399 43.8062C115.038 51.3664 121.603 57.5249 129.138 57.8339C133.863 58.0325 138.6 57.9443 143.326 57.9111C144.428 57.9111 145.518 57.6352 146.686 57.4807V112.135C129.766 106.903 115.104 110.302 104.727 124.937C94.5264 139.329 95.6941 154.306 105.696 168.852H104.22C84.9868 168.852 65.7644 168.852 46.531 168.852C39.9436 168.852 36 164.901 36 158.29C36 117.454 36 76.6294 36 35.8156C36 29.2819 39.9436 25.3528 46.4649 25.3418C68.6946 25.3418 90.9243 25.3418 113.165 25.3418C113.661 25.3418 114.145 25.3418 114.575 25.3418H114.564ZM91.3319 80.4481C81.9245 80.4481 72.517 80.4481 63.1207 80.4481C62.5589 80.4481 61.9971 80.415 61.4463 80.5033C59.7719 80.7792 58.7364 82.1478 58.8355 83.9026C58.9237 85.6133 59.9922 86.7501 61.6996 86.8936C62.2504 86.9487 62.8122 86.9267 63.374 86.9267C82.0787 86.9267 100.794 86.9267 119.499 86.9267C120.105 86.9267 120.722 86.9377 121.328 86.8604C122.749 86.6728 123.707 85.6685 123.883 84.2447C124.17 81.8608 122.87 80.4371 120.314 80.4371C110.653 80.426 100.993 80.4371 91.3319 80.4371V80.4481ZM84.9207 103.305C92.0919 103.305 99.2632 103.305 106.434 103.305C109.53 103.305 110.929 102.268 110.929 100.005C110.929 97.7427 109.53 96.7273 106.412 96.7273C92.0699 96.7273 77.7275 96.7273 63.385 96.7273C62.7792 96.7273 62.1623 96.7162 61.5564 96.8045C59.6507 97.1136 58.5712 98.6366 58.8576 100.557C59.122 102.345 60.3888 103.283 62.647 103.294C70.0716 103.305 77.4961 103.294 84.9207 103.294V103.305ZM76.67 70.6585C81.4948 70.6585 86.3197 70.6806 91.1446 70.6585C93.3477 70.6475 94.5705 69.4776 94.5925 67.4579C94.6145 65.3609 93.4138 64.18 91.1005 64.18C84.0945 64.1579 77.0775 64.169 70.0716 64.18C67.3837 64.18 64.6849 64.1579 61.9971 64.2021C60.2896 64.2352 59.2541 65.1071 58.9016 66.6081C58.3839 68.8265 59.8159 70.6475 62.1953 70.6696C67.0202 70.7027 71.8451 70.6806 76.67 70.6806V70.6585Z",
    fill: "url(#paint0_linear_121_60082)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163 145.621C162.923 162.043 149.891 175.089 133.621 175C117.351 174.923 104.286 161.701 104.396 145.422C104.507 129.308 117.825 116.208 133.996 116.307C150.068 116.407 163.066 129.551 162.989 145.621H163ZM132.663 149.715C130.393 147.376 128.367 145.223 126.263 143.171C124.853 141.791 122.87 141.824 121.625 143.093C120.38 144.374 120.391 146.327 121.779 147.74C124.952 150.962 128.146 154.174 131.385 157.342C133.313 159.218 135.67 158.776 136.86 156.393C139.9 150.3 142.929 144.197 145.97 138.105C146.124 137.785 146.3 137.476 146.432 137.145C147.049 135.489 146.003 133.16 144.306 132.432C142.731 131.759 141.332 132.41 140.385 134.264C139.944 135.125 139.526 135.997 139.096 136.858C137.014 141.029 134.921 145.201 132.663 149.715Z",
    fill: "url(#paint1_linear_121_60082)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.733 35.2977C120.733 33.0021 120.755 30.7175 120.733 28.4218C120.711 26.8325 121.493 25.8061 122.892 25.2433C124.214 24.7135 125.37 25.0887 126.362 26.082C132.795 32.5385 139.239 38.984 145.672 45.4294C146.752 46.511 147.049 47.7471 146.433 49.1929C145.827 50.6167 144.692 51.0912 143.26 51.0912C138.942 51.0912 134.613 51.1354 130.295 51.0692C124.908 50.9919 120.92 46.9856 120.766 41.5666C120.711 39.4806 120.766 37.3947 120.766 35.2977H120.733Z",
    fill: "url(#paint2_linear_121_60082)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_121_60082",
    x1: 91.3429,
    y1: 25.3418,
    x2: 91.3429,
    y2: 168.852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_121_60082",
    x1: 133.698,
    y1: 116.307,
    x2: 133.698,
    y2: 175.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_121_60082",
    x1: 133.741,
    y1: 25.0029,
    x2: 133.741,
    y2: 51.1057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_121_60082"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 127,
    height: 150,
    fill: "white",
    transform: "translate(36 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConceptValidation);
export default __webpack_public_path__ + "static/media/Concept_Validation.e406ce6ca25d0e7bf56fa1b47523f53b.svg";
export { ForwardRef as ReactComponent };